import { Component, OnInit, signal, OnDestroy, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { APIService } from '../../shared/api.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Gateway } from '../../classes/gateway';
import { Asset } from '../../classes/asset';
import { Setpoint } from '../../classes/setpoint';
import { GatewayIS } from 'app/classes/gateway-is';

@Component({
  selector: 'app-live-embed',
  templateUrl: './live-embed.component.html',
  styleUrls: ['./live-embed.component.css'],
  standalone: false
})
export class LiveEmbedComponent implements OnInit, OnDestroy {

  gateway = signal<GatewayIS>(null);
  assets = signal<Asset[]>(null);
  iframeSrc = signal<string>(null);
  showHelp = signal<boolean>(false);
  setpoints = signal<Setpoint[]>([]);
  selectedAsset = signal<Asset>(null);
  width = signal<number>(null);
  height = signal<number>(null);
  didIframeLoad = signal<boolean>(null);

  renderAsGrafana = signal<boolean>(false);

  can = { grafana: false };

  @HostListener('window:resize', ['$event'])
  onresize(event) {
    this.width.set(event.target.innerWidth);
    this.height.set(event.target.innerHeight);
    console.log('RESIZE', this.width(), this.height());
  }

  constructor(private router: Router, private route: ActivatedRoute, private apiService: APIService, public sanitizer: DomSanitizer) {


    route.params.subscribe((params: Params) => {

      const isGrafanaGateway = params['gatewayid'] === 'lw_com_4dml_lsh_haymarket_hub';

      this.can = { grafana: isGrafanaGateway && (apiService.getUserId() === 10 || apiService.getUserId() === 68) };
      apiService.getGateway(params['gatewayid']).then(gateway => {

        this.gateway.set(<GatewayIS>gateway);
        if (gateway instanceof GatewayIS) {
          const is = <GatewayIS>gateway;
          /*
                    if (gateway.id === 'lw_com_4dml_lsh_haymarket_hub') {
                      gateway.initialstate.version = 3;
                    }
          */
          switch (gateway.initialstate.version) {
            case 1:
              this.iframeSrc.set(`https://app.initialstate.com/embed/#/tiles/${is.initialstate.embedLink}`);
              break;
            case 2:
              this.iframeSrc.set(`https://iot.app.initialstate.com/embed/#/tiles/${is.initialstate.embedLink}`);
              break;
            case 3:
              this.renderAsGrafana.set(true);
              this.iframeSrc.set(`https://grafana.4dml.com/public-dashboards/2cc4c5e317da42aea8a7e7aaf0ffc316?theme=light&kiosk=true&hideLogo=true`);
          }
        }
      });
      this.apiService.getAssetsForGatewayId(params['gatewayid']).then(assets => this.assets.set(assets));
    });

    const setpoints = [];

    this.showHelp.set(false);
    for (let i = 0; i < 7; i++) {
      setpoints.push(new Setpoint(null, i, '', '', false, 0, 0, false));
    }
    this.setpoints.set(setpoints);
    this.apiService.setFullscreen(true);
  }

  ngOnInit() {

  }

  setIframeSource() {

    this.gateway.update(gateway => {

      switch (gateway.initialstate.version) {
        case 1:
          this.iframeSrc.set(`https://app.initialstate.com/embed/#/tiles/${gateway.initialstate.embedLink}`);
          break;
        case 2:
          this.iframeSrc.set(`https://iot.app.initialstate.com/embed/#/tiles/${gateway.initialstate.embedLink}`);
          break;
        case 3:
          this.renderAsGrafana.set(true);
          this.iframeSrc.set(`https://grafana.4dml.com/public-dashboards/2cc4c5e317da42aea8a7e7aaf0ffc316?theme=light&kiosk=true&hideLogo=true`);
      }
      return gateway;
    });
  }

  toggleGrafana() {
    const gateway = this.gateway();
    this.gateway.set(null);

    setTimeout(() => {
      this.renderAsGrafana.update(state => !state);
      this.didIframeLoad.set(null);
      gateway.initialstate.version = this.renderAsGrafana() ? 3 : 2;
      this.gateway.set(gateway);
      this.setIframeSource();

    }, 100);

  }

  iframeOnLoad(event: any) {
    if (this.renderAsGrafana()) {
      this.didIframeLoad.set(true);
      return;
    }

    if (this.didIframeLoad() !== null) {
      return;
    }

    if (event?.isTrusted === false) {
      console.log('iframe not trusted', event);

    } else {
      console.log('iframe trusted', event);
    }
    this.didIframeLoad.set(event?.isTrusted === true);

  }

  toggleHelp() {
    this.showHelp.update(state => !state);
    this.selectedAsset.set(null);
  }

  toggleAsset(asset: Asset) {
    if (this.selectedAsset()?.id === asset.id) {
      this.selectedAsset.set(null);
    } else {
      this.selectedAsset.set(asset);
    }
  }

  openInNewTab() {
    window.open(this.iframeSrc(), '_blank');
  }

  ngOnDestroy() {
    this.apiService.setFullscreen(false);
  }
}
